module.exports = __webpack_public_path__ + "img/callesdefuria.e82e1e85.jpg";